export const setLocation = (location: string) => {
  window.sessionStorage.setItem('location', location);
};

export const resetLocation = () => {
  window.sessionStorage.setItem('location', '');
};

export const getLocation = () => {
  const location = window.sessionStorage.getItem('location') || undefined;
  return location;
};
